import "@/polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { isChunkError, reloadForNewVersion } from "@/lib/lazyRetry";

// A deploy replaced the JS chunks this tab knows about → reload once instead of failing (outside React too, e.g. on-demand imports)
window.addEventListener("unhandledrejection", (e) => {
  if (isChunkError(e.reason) && reloadForNewVersion()) e.preventDefault();
});

// Benign browser notification — prevent it from triggering the dev error overlay
window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    setTimeout(() => {
      const o = document.getElementById("webpack-dev-server-client-overlay");
      if (o) o.remove();
    }, 0);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => console.log('SW registered:', reg.scope),
      (err) => console.log('SW registration failed:', err)
    );
  });
}
